module.exports = __webpack_public_path__ + "media/images/new-ui-images/patient-icon-blue-48dc08267bd988d5c93b49203ce664b7.svg";